import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/index';
import { UtilsService } from '../../../services/api/utils.service';
import { Expiration } from '../../../models/b2b/expiration';
import { User } from '../../../../shared/models/b2b/user';
import { SoledadUserService } from 'app/shared/services/b2b/user.service';

@Component({
    selector: 'app-item-expiration-list',
    templateUrl: './item-expiration-list.component.html',
})
export class ItemExpirationListComponent {
    @Input() item: Expiration;
    user: User;

    constructor(private store: Store<AppState>, public us: SoledadUserService) {}

    subscribeUser() {
        this.store
            .select((state) => state.user.data)
            .subscribe((data) => {
                this.user = data;
            });
    }

    isComercial(tipo: string): boolean {
        return tipo === 'COMERCIAL';
    }
}
